import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectAuthLoading,
  selectAuthInitializing,
} from "../../store/selectors/authSelectors";
import LoadingSpinner from "@/components/common/LoadingSpinner";

const PublicRoute = ({ children, redirectTo = "/admin" }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const initializing = useSelector(selectAuthInitializing);

  console.log("Inside PUBLIC ROUTE. Redux isAuthenticated:", isAuthenticated);

  // Show loading state while checking session or initializing
  // if (loading || initializing) {
  if (initializing) {
    return <LoadingSpinner fullscreen text="Checking your session..." />;
  }

  // If user is already authenticated, redirect (only after initialization is complete)
  if (isAuthenticated) {
    console.log("isAuthenticated TRUE! Navigating to", redirectTo);
    return <Navigate to={redirectTo} replace />;
  }

  // Otherwise, allow access to public page
  return children;
};

export default PublicRoute;

// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { selectIsAuthenticated } from "../../store/selectors/authSelectors";

// /**
//  * PublicRoute component that redirects authenticated users away from auth pages
//  */
// const PublicRoute = ({ children, redirectTo = "/admin" }) => {
//   const isAuthenticated = useSelector(selectIsAuthenticated);
//   console.log("Inside PUBLIC ROUTE. Redux isAuthenticated ", isAuthenticated);
//   // If user is already authenticated, redirect them to the specified route
//   if (isAuthenticated) {
//     console.log("isAuthenticated TRUE! Navigating to /admin");
//     return <Navigate to={redirectTo} replace />;
//   }

//   return children;
// };

// export default PublicRoute;
